import { ThemeProvider } from '@mui/material/styles';
import { Provider } from 'react-redux';
import { getPersistor, getStore } from 'redux/reemaStore.util';
import { DialogProvider } from 'utilities/dialog-context/DialogContext';
import { DialogProvider as DialogProviderV2 } from '../../stories/dialogs/DialogProvider';
import { PersistGate } from 'redux-persist/integration/react';
import { useGetAppConfig } from 'utilities/appConfigHook.hook';
import './app.scss';
import InitialDataHelper from './InitialDataHelper';
import { LanguageProvider } from 'utilities/language-provider';
import { SideMenuDrawerProvider } from '@act/utilities/SideMenuDrawerContext';
import {
  ReemaThemeV2,
  SettingsProvider,
  DisplayModeProvider,
  DrawerProvider,
  RecapProvider,
  RecapDrawer,
} from '@act/storybook';
import { Outlet } from 'react-router-dom';
import { InteractionsDialogRoot } from 'react-components/dialog-forms/hooks/useInteractionsDialog.hook';
import ToastPortal from 'react-components/portals/ToastPortal';
import { TrackingProvider } from '../tracking/TrackingContext';
import { JustInTimeCallDisplay } from '../calls/JustInTimeCallDisplay';

const CareApp = () => {
  const configLoaded = useGetAppConfig();
  if (!configLoaded) {
    return null;
  }

  return (
    <Provider store={getStore()}>
      <PersistGate persistor={getPersistor()}>
        <LanguageProvider>
          <InitialDataHelper />
          <SettingsProvider>
            <ThemeProvider theme={ReemaThemeV2.LIGHT_MODE}>
              <TrackingProvider contextName="care-app">
                <DrawerProvider>
                  <DisplayModeProvider>
                    <RecapProvider>
                      <DialogProviderV2>
                        <DialogProvider>
                          <SideMenuDrawerProvider>
                            <Outlet />
                            <InteractionsDialogRoot />
                            <ToastPortal />
                            <JustInTimeCallDisplay />
                            <RecapDrawer />
                          </SideMenuDrawerProvider>
                        </DialogProvider>
                      </DialogProviderV2>
                    </RecapProvider>
                  </DisplayModeProvider>
                  <div id="toast-portal"></div>
                </DrawerProvider>
              </TrackingProvider>
            </ThemeProvider>
          </SettingsProvider>
        </LanguageProvider>
      </PersistGate>
    </Provider>
  );
};

export default CareApp;
